class Can {
  static access (name) {
    if (!this.$store.commit('checkPermission', name)) {
      return true
    }
    if (this.$store.commit('checkUserAccess', name)) {
      return true
    }
    return false
  }
}
export default Can
